(function () {
  const PROPERTY = '_brinde_automatico';
  const SOURCE = 'auto-gift';
  const root = window.Shopify?.routes?.root || '/';
  const cartAddUrl = window.routes?.cart_add_url || `${root}cart/add.js`;
  const cartUpdateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;
  const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : `${root}cart.js`;

  function parseSkus(value) {
    return (Array.isArray(value) ? value : String(value || '').split(/[\n,;]+/))
      .map((sku) => String(sku).trim().toLowerCase())
      .filter(Boolean);
  }

  function getConfig() {
    const config = window.autoGift;
    if (!config) return null;

    // Compatibilidade com o formato antigo (uma única regra na raiz do objeto).
    const rawRules = Array.isArray(config.rules)
      ? config.rules
      : [{ enabled: true, variantId: config.variantId, available: config.available, triggerSkus: config.triggerSkus }];

    const rules = rawRules
      .map((rule) => {
        const variantId = Number(rule?.variantId);

        return {
          enabled: rule?.enabled !== false,
          available: rule?.available === true,
          variantId: Number.isFinite(variantId) ? variantId : 0,
          triggerSkus: parseSkus(rule?.triggerSkus),
        };
      })
      .filter((rule) => rule.variantId && rule.triggerSkus.length > 0);

    return {
      enabled: config.enabled === true,
      removeWhenTriggerGone: config.removeWhenTriggerGone !== false,
      rules,
    };
  }

  function getSectionsToRender() {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
      sections.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    }

    if (mainCartFooter) {
      sections.push({ id: 'main-cart-footer', section: mainCartFooter.dataset.id, selector: '.js-contents' });
    }

    if (document.querySelector('cart-drawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }

    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });

    return sections.filter(
      (section, index, allSections) =>
        section.section && allSections.findIndex((candidate) => candidate.section === section.section) === index
    );
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return null;
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  function renderSections(sections, sectionsPayload, cart) {
    sections.forEach((section) => {
      const container = document.getElementById(section.id);
      const target = container?.querySelector(section.selector) || container;
      const html = getSectionInnerHTML(sectionsPayload?.[section.section], section.selector);

      if (target && html !== null) target.innerHTML = html;
    });

    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
    }
  }

  function withSource(url) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}source=${SOURCE}`;
  }

  async function fetchCart() {
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Falha ao consultar o carrinho: ${response.status}`);
    return response.json();
  }

  async function postCart(url, body) {
    const response = await fetch(withSource(url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error(`Falha ao atualizar o carrinho: ${response.status}`);
    return response.json();
  }

  function isGift(item) {
    return String(item.properties?.[PROPERTY] || '').toLowerCase() === 'true';
  }

  function getDesiredGiftVariantIds(cart, config) {
    const desired = new Set();
    const giftLines = cart.items.filter(isGift);

    config.rules.forEach((rule) => {
      const triggered =
        config.enabled &&
        rule.enabled &&
        cart.items.some(
          (item) => !isGift(item) && rule.triggerSkus.includes(String(item.sku || '').trim().toLowerCase())
        );

      if (triggered) {
        if (rule.available) desired.add(rule.variantId);
        return;
      }

      // Regra não disparada: só remove o brinde se a loja pediu isso.
      if (!config.removeWhenTriggerGone && giftLines.some((item) => item.id === rule.variantId)) {
        desired.add(rule.variantId);
      }
    });

    // Brindes que não pertencem a nenhuma regra (regra removida/alterada) só saem
    // do carrinho quando a remoção automática está ligada.
    if (!config.removeWhenTriggerGone) {
      const ruleVariantIds = config.rules.map((rule) => rule.variantId);
      giftLines.forEach((item) => {
        if (!ruleVariantIds.includes(item.id)) desired.add(item.id);
      });
    }

    return desired;
  }

  function getGiftPlan(cart, config) {
    const giftLines = cart.items.filter(isGift);
    const desired = getDesiredGiftVariantIds(cart, config);

    const updates = {};
    const kept = new Set();

    giftLines.forEach((item) => {
      if (desired.has(item.id) && !kept.has(item.id)) {
        kept.add(item.id);
        if (item.quantity !== 1) updates[item.key] = 1;
        return;
      }

      updates[item.key] = 0;
    });

    const additions = [...desired].filter((variantId) => !kept.has(variantId));

    return { updates, additions };
  }

  function isNormalized(plan) {
    return Object.keys(plan.updates).length === 0 && plan.additions.length === 0;
  }

  async function applyGiftNormalization(cart, config, sectionIds, sectionsUrl) {
    const plan = getGiftPlan(cart, config);
    if (isNormalized(plan)) return null;

    let response = null;

    if (Object.keys(plan.updates).length > 0) {
      response = await postCart(cartUpdateUrl, {
        updates: plan.updates,
        sections: sectionIds,
        sections_url: sectionsUrl,
      });
    }

    if (plan.additions.length > 0) {
      response = await postCart(cartAddUrl, {
        items: plan.additions.map((variantId) => ({
          id: variantId,
          quantity: 1,
          properties: { [PROPERTY]: 'true' },
        })),
        sections: sectionIds,
        sections_url: sectionsUrl,
      });
    }

    return response;
  }

  let giftLock = Promise.resolve();

  function withGiftLock(task) {
    const run = giftLock.then(task, task);
    giftLock = run.then(
      () => {},
      () => {}
    );
    return run;
  }

  let checking = false;
  let pending = false;
  let timer;

  function scheduleCheck(delay = 250) {
    clearTimeout(timer);
    timer = setTimeout(checkCart, delay);
  }

  async function checkCart() {
    const config = getConfig();
    if (!config) return;

    if (checking) {
      pending = true;
      return;
    }

    checking = true;

    try {
      await withGiftLock(async () => {
        const cart = await fetchCart();
        if (!Array.isArray(cart.items)) return;

        const sections = getSectionsToRender();
        const sectionIds = sections.map((section) => section.section);
        const response = await applyGiftNormalization(cart, config, sectionIds, window.location.pathname);

        if (!response) return;

        const updatedCart = await fetchCart();
        renderSections(sections, response.sections, updatedCart);
      });
    } catch (error) {
      console.error('Erro ao gerenciar o brinde automático:', error);
    } finally {
      checking = false;

      if (pending) {
        pending = false;
        scheduleCheck(0);
      }
    }
  }

  function normalizeSectionIds(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value !== 'string' || !value.trim()) return [];

    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {}

    return value
      .split(',')
      .map((section) => section.trim())
      .filter(Boolean);
  }

  function parseRequestedSections(init) {
    const body = init?.body;

    if (body instanceof FormData || body instanceof URLSearchParams) {
      return {
        sectionIds: normalizeSectionIds(body.get('sections')),
        sectionsUrl: body.get('sections_url') || window.location.pathname,
      };
    }

    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        return {
          sectionIds: normalizeSectionIds(parsed.sections),
          sectionsUrl: parsed.sections_url || window.location.pathname,
        };
      } catch {
        return { sectionIds: [], sectionsUrl: window.location.pathname };
      }
    }

    return { sectionIds: [], sectionsUrl: window.location.pathname };
  }

  async function mergeGiftIntoResponse(response, requestInit) {
    const config = getConfig();
    if (!config || !config.enabled) return response;

    const { sectionIds: requestedSectionIds, sectionsUrl } = parseRequestedSections(requestInit);
    if (requestedSectionIds.length === 0) {
      scheduleCheck();
      return response;
    }

    const originalPayload = await response.clone().json();

    const merged = await withGiftLock(async () => {
      const cart = await fetchCart();
      if (!Array.isArray(cart.items)) return null;

      if (isNormalized(getGiftPlan(cart, config))) return { sections: null, cart };

      const knownSections = getSectionsToRender();
      const extraSections = knownSections.filter((section) => !requestedSectionIds.includes(section.section));
      const allSectionIds = [
        ...requestedSectionIds,
        ...extraSections.map((section) => section.section),
      ].filter((section, index, sections) => sections.indexOf(section) === index);

      const latest = await applyGiftNormalization(cart, config, allSectionIds, sectionsUrl);
      if (!latest?.sections) return null;

      const updatedCart = await fetchCart();
      if (extraSections.length > 0) renderSections(extraSections, latest.sections, updatedCart);

      return { sections: latest.sections, cart: updatedCart };
    });

    if (!merged) {
      scheduleCheck();
      return response;
    }

    if (!merged.sections) return response;

    const mergedSections = Object.fromEntries(
      requestedSectionIds
        .map((id) => [
          id,
          id === 'cart-notification-product' ? originalPayload.sections?.[id] : merged.sections[id],
        ])
        .filter(([, html]) => html !== undefined)
    );
    const cartPayload =
      typeof originalPayload.item_count === 'number' && Array.isArray(originalPayload.items) ? merged.cart : {};

    return new Response(JSON.stringify({ ...originalPayload, ...cartPayload, sections: mergedSections }), {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    });
  }

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isCartMutation = /\/cart\/(add|change|update)(\.js)?([?#]|$)/.test(requestUrl);

    return originalFetch.apply(this, args).then(async (response) => {
      if (!response.ok || !isCartMutation || requestUrl.includes(`source=${SOURCE}`)) return response;

      try {
        return await mergeGiftIntoResponse(response, args[1]);
      } catch (error) {
        console.error('Erro ao gerenciar o brinde automático:', error);
        scheduleCheck();
        return response;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleCheck(0), { once: true });
  } else {
    scheduleCheck(0);
  }
})();
